export const getDotcmsImageURL = ({ src, width, quality, raw = false }) => {
    const MAX_WIDTH = 1024;
    const DEFAULT_QUALITY = 75;

    if (!src || typeof src !== 'string') {
        return '';
    }

    const isExternal = src.startsWith('http');

    if (isExternal) return src;

    const isDotcmsAsset = src.includes('/dA/');
    const imageSRC = isDotcmsAsset ? src : `/dA/${src}`;

    const isSVG = imageSRC.includes('.svg');
    const isGIF = imageSRC.includes('.gif');

    if (isGIF) return imageSRC;
    if (isSVG) return `${imageSRC}/100q`;

    if (raw) return imageSRC;

    if (width == null) {
        return `${imageSRC}/${quality || DEFAULT_QUALITY}q`;
    }

    const maxWidth = Math.min(width, MAX_WIDTH);
    return `${imageSRC}/${maxWidth}maxw/${quality || DEFAULT_QUALITY}q`;
};
